exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".profile {\n  width: 135px;\n  top: 34px;\n  left: -35px !important;\n  background-color: white;\n  cursor: pointer;\n  height: auto; }\n\n.style {\n  position: absolute;\n  right: 59px; }\n\n.header-profile .profile-width {\n  width: auto !important; }\n\n.content-admin {\n  padding-top: 72px;\n  padding-left: 250px !important; }\n\n@media only screen and (min-width: 980px) {\n  body.menu-pin .page-container .page-content-wrapper .content,\n  .content-fit-in,\n  .content {\n    padding-left: 0 !important; } }\n\n@media only screen and (max-width: 992px) {\n  .content-admin {\n    padding-left: 0 !important; } }\n\n.modal-content {\n  width: auto; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/jenkins/hornbillfx-elms-v2/src/app/feature-modules/admin/admin.component.scss
// module id = ../../../../../src/app/feature-modules/admin/admin.component.scss
// module chunks = main